export default __webpack_public_path__ + "static/media/trace_contact.c02175a2.svg";